import React, { useState } from 'react';
import { matchSorter } from 'match-sorter';
import ModalCadastro from '../_base/modal-cadastro';
import FormGroupHeader from '../_base/form-group-header';

import EquipeService from '../../services/equipe-service';
import ProdutoService from '../../services/produto-service';

import './styles.scss';
import '../modal-cadastro-equipe-carteira/styles.scss';

export default function ModalCarteira(props) {
  const {
    showModal,
    setShowModal,
    equipeId,
    usuarioId
  } = props;

  const emptyCarteira = {
    usuario: {},
    equipe: {}
  };

  const [carteira, setCarteira] = useState({
    ...emptyCarteira
  });

  const [carteiraClientes, setCarteiraClientes] = useState([]);
  const [carteiraRepresentadas, setCarteiraRepresentadas] =
    useState([]);

  const [filteredClientes, setFilteredClientes] = useState([]);
  const [filteredRepresentadas, setFilteredRepresentadas] =
    useState([]);

  const [carteiraCategorias, setCarteiraCategorias] = useState([]);
  const [filterProdutos, setFilterProdutos] = useState('');

  React.useEffect(() => {
    reset();

    if (
      showModal &&
      equipeId > 0 &&
      usuarioId
    ) {
      getCarteira();
    }
  }, [showModal, equipeId, usuarioId]);

  function reset() {
    setCarteira({ ...emptyCarteira });
    setCarteiraClientes([]);
    setCarteiraRepresentadas([]);
    setFilteredClientes([]);
    setFilteredRepresentadas([]);
    setCarteiraCategorias([]);
    setFilterProdutos('');
  }

  async function getCarteira() {
    window.showLoader();

    try {
      const [
        responseCarteira,
        responseCategorias
      ] = await Promise.all([
        EquipeService.getCarteiraEquipeAsync(equipeId),
        ProdutoService.listCategoriasComProdutosAsync(
          usuarioId,
          equipeId
        )
      ]);

      const carteiraRecebida =
        responseCarteira?.data?.data || {
          ...emptyCarteira,
          clientes: [],
          representadas: []
        };

      const clientes = carteiraRecebida.clientes || [];
      const representadas =
        carteiraRecebida.representadas || [];

      setCarteira(carteiraRecebida);
      setCarteiraClientes(clientes);
      setCarteiraRepresentadas(representadas);
      setFilteredClientes(clientes);
      setFilteredRepresentadas(representadas);

      const categoriasRecebidas =
        Array.isArray(responseCategorias?.data?.data)
          ? responseCategorias.data.data
          : [];

      const categoriasDisponiveis = categoriasRecebidas
        .map((categoria) => {
          const produtosDisponiveis =
            (categoria.produtos || []).filter(
              (produto) => produto.selecionado
            );

          return {
            ...categoria,
            produtos: produtosDisponiveis
          };
        })
        .filter(
          (categoria) => categoria.produtos.length > 0
        );

      setCarteiraCategorias(categoriasDisponiveis);
    } finally {
      window.hideLoader();
    }
  }

  const filteredProdutos = React.useMemo(() => {
    const termo = filterProdutos.trim();

    if (!termo) {
      return carteiraCategorias;
    }

    const categoriasEncontradas = matchSorter(
      carteiraCategorias,
      termo,
      {
        keys: ['nome']
      }
    );

    const categoriasEncontradasIds = new Set(
      categoriasEncontradas.map(
        (categoria) => categoria.produtoCategoriaId
      )
    );

    return carteiraCategorias
      .map((categoria) => {
        if (
          categoriasEncontradasIds.has(
            categoria.produtoCategoriaId
          )
        ) {
          return categoria;
        }

        const produtos = matchSorter(
          categoria.produtos || [],
          termo,
          {
            keys: [
              'nome',
              'codigoNaRepresentada'
            ]
          }
        );

        return {
          ...categoria,
          produtos
        };
      })
      .filter(
        (categoria) => categoria.produtos.length > 0
      );
  }, [carteiraCategorias, filterProdutos]);

  return (
    <ModalCadastro
      showModal={showModal}
      setShowModal={setShowModal}
      headerText={`${
        carteira?.usuario?.nome || ''
      } - ${
        carteira?.equipe?.nome || ''
      } - CARTEIRA`}
    >
      <div className="modal-body">
        <div className="row carteira">
          <div className="col-lg-6">
            <FormGroupHeader text="CLIENTES" />

            <input
              type="search"
              className="form-control mb-3"
              placeholder="Filtrar"
              onChange={(event) => {
                setFilteredClientes(
                  matchSorter(
                    carteiraClientes || [],
                    event.target.value,
                    {
                      keys: [
                        'nomeFantasia',
                        'razaoSocial',
                        'cnpj'
                      ]
                    }
                  )
                );
              }}
            />

            {filteredClientes.map((cliente, index) => (
              <div key={index} className="d-block">
                <div className="list-item mb-3">
                  <span>
                    {cliente.nomeFantasia}
                    {cliente.inadimplente
                      ? ' - Bloqueado'
                      : ''}
                  </span>

                  <br />

                  <span className="fantasia">
                    {cliente.razaoSocial} - {cliente.cnpj}
                  </span>

                  <br />

                  <span className="cnpj">
                    {cliente.logradouro} - {cliente.bairro} -{' '}
                    {cliente.cidade}
                  </span>
                </div>
              </div>
            ))}
          </div>

          <div className="col-lg-6">
            <FormGroupHeader text="REPRESENTADAS" />

            <input
              type="search"
              className="form-control mb-3"
              placeholder="Filtrar"
              onChange={(event) => {
                setFilteredRepresentadas(
                  matchSorter(
                    carteiraRepresentadas || [],
                    event.target.value,
                    {
                      keys: [
                        'nomeFantasia',
                        'razaoSocial',
                        'cnpj'
                      ]
                    }
                  )
                );
              }}
            />

            {filteredRepresentadas.map(
              (representada, index) => (
                <div key={index} className="d-block">
                  <div className="list-item mb-3">
                    <span>{representada.nomeFantasia}</span>

                    <br />

                    <span className="fantasia">
                      {representada.razaoSocial} -{' '}
                      {representada.cnpj}
                    </span>
                  </div>
                </div>
              )
            )}
          </div>

          <div className="col-lg-6">
            <FormGroupHeader text="MIX DE PRODUTOS" />

            <input
              type="search"
              className="form-control mb-3"
              placeholder="Filtrar"
              value={filterProdutos}
              onChange={(event) =>
                setFilterProdutos(event.target.value)
              }
            />

            <div
              className="list-categorias"
              style={{
                maxHeight: '600px',
                overflow: 'auto'
              }}
            >
              {filteredProdutos.map((categoria) => (
                <ul
                  key={categoria.produtoCategoriaId}
                  className="d-block p-0 mb-2"
                >
                  <li className="list-item-header mb-1 d-flex align-items-center justify-content-between">
                    <div className="selecao-categoria">
                      <span className="list-item-label">
                        {categoria.nome}
                      </span>
                    </div>
                  </li>

                  {(categoria.produtos || []).map(
                    (produto, indexProduto) => (
                      <div key={produto.produtoId}>
                        <div className="list-item d-flex align-items-center ml-3">
                          <span className="list-item-label">
                            {produto.codigoNaRepresentada} -{' '}
                            {produto.nome}
                          </span>
                        </div>

                        {indexProduto + 1 <
                        categoria.produtos.length ? (
                          <hr />
                        ) : null}
                      </div>
                    )
                  )}
                </ul>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="modal-footer">
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => setShowModal(false)}
        >
          Fechar
        </button>
      </div>
    </ModalCadastro>
  );
}